export default function Home() {
  return <h1>Hello, World!</h1>
}